'use client'
import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import Cookies from 'js-cookie';
import { Load } from './loading';

const ProtectedRoute = ({ children }) => {
  const router = useRouter();
  const [isAuthorized, setIsAuthorized] = useState(false)

  useEffect(() => {
    const checkAuth = () => {
      try {
          const details = Cookies.get('mentor_details');
          const currentPath = window.location.pathname;
          if (currentPath === '/auth/signup') {
            setIsAuthorized(true);
            return;
          }
          if (!details) {
            setIsAuthorized(true);
            router.push("/auth/login");
            return;
          }
          setIsAuthorized(true);
      } catch (error) {
        // console.log(error);
        setIsAuthorized(true);
        router.push("/auth/login");
      }
    }
    checkAuth()
  }, []);
  
  if(!isAuthorized){
      return (
        <Load />
      );
    }
  return children;
};

export default ProtectedRoute;
